import { IStyle, mergeStyleSets } from '@fluentui/react';
import React, { useCallback, useState } from 'react';
import { BwjConscientiousContainer } from '../../../../framework/components/bwj-conscientious-container';

interface IProductTileContainerProps {}

const getStyleClasses = () => {
  const root: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 28,
    flexWrap: 'wrap',
    margin: '0 auto',
    width: '100%',
  };

  return mergeStyleSets({
    root,
  });
}

export const ProductTileContainer: React.FunctionComponent<IProductTileContainerProps> = (props) => {
  const cs = getStyleClasses();
  const [containerWidth, setContainerWidth] = useState<React.CSSProperties>({ maxWidth: 340 });

  const onWidthChange = useCallback((width: number) => {
    let cw = 340;
    if(width >= 1812) { cw = 1812; } // 5 tiles in a row
    else if(width >= 1444) { cw = 1444; } // 4
    else if(width >= 1104) { cw = 1104; } // 3
    else if(width >= 708) { cw = 708; } // 2

    setContainerWidth({ maxWidth: cw });
  }, []);

  return (
    <BwjConscientiousContainer
      pollingFrequency={1000}
      onWidthChange={onWidthChange}
    >
      <div className={cs.root} style={containerWidth}>
        {props.children}
      </div>
    </BwjConscientiousContainer>
  );
};
